package one.healthium.content.navigation.content

import androidx.lifecycle.ViewModelStoreOwner
import com.arkivanov.decompose.ComponentContext
import one.healthium.decompose.viewModelStoreOwner
import one.healthium.insights.domain.content.ContentOptions
import one.healthium.insights.domain.models.ActionModel

class DefaultContentComponent(
    componentContext: ComponentContext,
    override val options: ContentOptions,
    private val onBackClicked: () -> Unit,
    private val onActionClicked: (ActionModel) -> Unit,
) : ContentComponent, ComponentContext by componentContext, ViewModelStoreOwner by componentContext.viewModelStoreOwner() {

    override fun onBackClicked() {
        onBackClicked.invoke()
    }

    override fun onActionClicked(actionModel: ActionModel) {
        onActionClicked.invoke(actionModel)
    }
}